<template>
    <div>
        <sav-template :title="$t('user.notifications.casino-title')">
            <div
            v-for="(notif, notifIndex) in notifs"
            :key="'notif-' + notifIndex"
            class="bg-white border my-rounded shadow p-4 mb-3"
            >
                <span v-if="notif.lu == 0" class="bg-green-100 text-green-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded">Nouveau</span>
                <div :class="notif.lu == 0 ? 'mt-2' : ''">
                    <div class="font-light text-xs mb-1">{{transformDate(notif.date)}}</div>
                    <div class="font-bold mb-1">{{notif.objet}}</div>
                    <div class="font-light mb-2">{{notif.texte}}</div>
                    <div class="font-light text-xs text-gray-400">Référence dossier: {{notif.ref_dossier}}</div>
                </div>
            </div>
            <div v-if="notifs && notifs.length <= 0">
                Aucune notification
            </div>
        </sav-template>
    </div>
</template>

<script>
import apiService from '@/services/api.service'
import moment from 'moment'


export default {
    data() {
        return {
            user: null,
            notifs: []
        }
    },
    methods: {
        async readNotifications() {
            for (let notifIndex in this.notifs) {
                await apiService.post('setlu', {
                    id_notif: this.notifs[notifIndex].id
                })
            }
        },

        transformDate(date) {
            return moment(date).lang("fr").format('LLL');
        },

        async getNotifs() {
            await apiService.post('getnotif', {
                id_conso: this.user.id
            }).then((response) => {
                this.notifs = response.data.posts.post
                if (this.notifs == 0) {
                    this.notifs = []
                }
                this.readNotifications()
            })
        }
    },
    async mounted() {
        this.user = await apiService.getUser()
        this.getNotifs()
        
    }
};
</script>



// WEBPACK FOOTER //
// src/companies/casino/views/user/Notifications.vue